import { PrimaryButton } from '@artprov/design-system'
import PropTypes from 'prop-types'

export default function CargarNominaButton({ onClick, disabled, ...props }) {
  return (
    <PrimaryButton IconLeft="add" size="small" onClick={onClick} disabled={disabled} {...props}>
      Cargar nómina
    </PrimaryButton>
  )
}

CargarNominaButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
